// libraries
import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

// auth
import {SIZE} from '../components';

// shared
import CredentialsInput from 'shared/auth/components/credentials-input';
import FormButton from 'shared/components/button';
import GoogleButton from 'shared/components/google-button';
import Separator from 'shared/components/separator';
import HighSchoolStudent from '-!svg-react-loader!shared/img/hs-student.svg';
import CommunityCollegeStudent from '-!svg-react-loader!shared/img/cc-student.svg';
import Educator from '-!svg-react-loader!shared/img/educator.svg';
import ParentOrGuardian from '-!svg-react-loader!shared/img/parent-guardian.svg';
import GoogleOAuth from 'shared/modules/google-oauth';

const USER_MAP = {
  'hs-student': {
    icon: <HighSchoolStudent width={SIZE} height={SIZE} />,
    text: 'High School Student'
  },
  // Note: comm-college-student is a legacy parameter
  'comm-college-student': {
    icon: <CommunityCollegeStudent width={SIZE} height={SIZE} />,
    text: 'Community College Student'
  },
  'cc-student': {
    icon: <CommunityCollegeStudent width={SIZE} height={SIZE} />,
    text: 'Community College Student'
  },
  teacher: {
    icon: <Educator width={SIZE} height={SIZE} />,
    text: 'Teacher'
  },
  counselor: {
    icon: <Educator width={SIZE} height={SIZE} />,
    text: 'Counselor'
  },
  mentor: {
    icon: <Educator width={SIZE} height={SIZE} />,
    text: 'Mentor'
  },
  communityCollegeStaff: {
    icon: <Educator width={SIZE} height={SIZE} />,
    text: 'Community College Staff Member'
  },
  parent: {
    icon: <ParentOrGuardian width={SIZE} height={SIZE} />,
    text: 'Parent or Guardian'
  }
};

export default class UserSignUp extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    fields: PropTypes.shape({
      identifier: PropTypes.object.isRequired,
      password: PropTypes.object.isRequired
    }).isRequired,
    submitting: PropTypes.bool.isRequired,
    match: PropTypes.object.isRequired,
    googleSignUp: PropTypes.func.isRequired,
    setNavigationAnnouncement: PropTypes.func.isRequired
  }

  componentDidMount() {
    const {
      match: {
        params: {
          userType,
          userSubtype
        }
      }
    } = this.props;

    this.props.setNavigationAnnouncement(`${USER_MAP[userSubtype || userType].text} Sign Up`);
    GoogleOAuth.init([]);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      googleSignUp,
      fields: {
        identifier,
        password
      },
      match: {
        params: {
          userType,
          userSubtype
        }
      }
    } = this.props;

    return (
      <React.Fragment>
        <div className="auth-signup-user-icon">{USER_MAP[userSubtype || userType].icon}</div>
        <h1 className="auth-signup-user-header">Sign Up as a {USER_MAP[userSubtype || userType].text}</h1>
        <GoogleButton
          size="medium"
          buttonName="auth-login-google"
          modifierClass="auth-shared-google-button"
          onClick={googleSignUp}
        >Sign Up with Google
        </GoogleButton>
        <Separator>Or</Separator>
        <form onSubmit={handleSubmit}>
          <CredentialsInput
            identifier={identifier}
            password={password}
            identifierHeader={userSubtype ? 'Official Work Email' : 'Email'} />
          <p className="auth-signup-disclaimer">
            By signing up, you agree to our <Link to="/terms_of_use" className="auth-shared-link caption">Terms of Use</Link> and <Link to="/privacy_policy" className="auth-shared-link caption">Privacy and Cookie Policy</Link>.
          </p>
          <FormButton
            size="large"
            type="submit"
            modifierClass="auth-shared-submit-button"
            width="100%"
            disabled={submitting}
          >{submitting ? 'Signing Up...' : 'Continue'}
          </FormButton>
        </form>
      </React.Fragment>
    );
  }
}
